/**
 * Abbrechbare Requests pro Aktions-Typ (Stale-Response-Schutz) – EINE Implementierung für alle
 * Stores (vorher je Store eine eigene Map-Kopie). Ein neuer Aufruf derselben Aktion bricht den
 * Vorgänger ab; abgebrochene Requests erzeugen keine Fehler-Toasts (`isAbortError`).
 */
export interface RequestRegistry {
    /** Bricht den laufenden Request derselben Aktion ab und liefert das Signal für den neuen. */
    begin(key: string): AbortSignal;
    /** Bricht (nur) den laufenden Request dieser Aktion ab. */
    abort(key: string): void;
    /** Bricht alle laufenden Requests ab (Reset – deren Antworten sind bedeutungslos). */
    abortAll(): void;
}

export function createRequestRegistry(): RequestRegistry {
    const aborts = new Map<string, AbortController>();

    return {
        begin(key: string): AbortSignal {
            aborts.get(key)?.abort();
            const controller = new AbortController();
            aborts.set(key, controller);
            return controller.signal;
        },
        abort(key: string): void {
            aborts.get(key)?.abort();
        },
        abortAll(): void {
            for (const controller of aborts.values()) controller.abort();
            aborts.clear();
        },
    };
}
